import { render, staticRenderFns } from "./EmailRegisterAccess.vue?vue&type=template&id=1f253308"
import script from "./EmailRegisterAccess.vue?vue&type=script&lang=js"
export * from "./EmailRegisterAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports